import React, { useEffect } from 'react'
import { Box } from '@material-ui/core'
import { connect } from 'react-redux'

import Header from '../components/teams/admin/Header'
import { selectAccount } from '../redux/selectors/accountSelectors'
import { getTeamReportUrlStart } from '../redux/modules/teamReport'
import { loadAccountStart } from '../redux/modules/account'

function PageTeamReporting({ account, loadAccountStart, match, getTeamReportUrlStart, reportUrl }) {
  const accountId = match.params.accountId

  useEffect(() => {
    getTeamReportUrlStart()
  }, [getTeamReportUrlStart])

  useEffect(() => {
    if (account === undefined) {
      loadAccountStart(accountId)
    }
  }, [account, accountId, loadAccountStart])

  if (reportUrl === '') {
    return null
  }

  return (
    <>
      <Header account={account} name={account?.name} />
      <Box mt={3} bgcolor="white">
        <iframe title="Usage Report" src={reportUrl} width="100%" height="1000" />
      </Box>
    </>
  )
}
const mapStateToProps = state => {
  const account = selectAccount(state)
  const reportUrl = state.teamReport.reportUrl
  return {
    account,
    reportUrl,
  }
}

const mapDispatchToProps = {
  getTeamReportUrlStart,
  loadAccountStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(PageTeamReporting)
